import { provideApi, provideStorage } from '@nequi/design-system-lib/logic';
import { environment } from '@environments/environment';
import { ConfirmCashOutRepository } from '@private/modules/cash-out-payment/core/repositories/confirm-cash-out/confirm-cash-out.repository';
import { GetCashOutRepository } from '@private/modules/cash-out-payment/core/repositories/get-cash-out/get-cash-out.repository';
import { ValidationRepository } from '@private/modules/cash-out-payment/core/repositories/validation/validation.repository';
import { ConfirmCashOutImplRepository } from '@private/modules/cash-out-payment/data/repositories/confirm-cash-out/confirm-cash-out-impl.repository';
import { GetCashOutImplRepository } from '@private/modules/cash-out-payment/data/repositories/get-cash-out/get-cash-out-impl.repository';
import { ValidationImplRepository } from '@private/modules/cash-out-payment/data/repositories/validation/validation-impl.repository';
import { CancelCashOutInteractor } from '@shared/core/interactor/cancel-cash-out/cancel-cash-out.interactor';
import { CancelCashOutRepository } from '@shared/core/repositories/cancel-cash-out/cancel-cash-out.repository';
import { CancelCashOutImplRepository } from '@shared/data/repositories/cancel-cash-out/cancel-cash-out-impl.repository';
import { FingerprintService } from '@shared/services/fingerprint/fingerprint.service';

export const serviceProvider = [
  provideApi({ url: environment.apiServices.apiUrl }),
  provideStorage(environment.secretKey),
  FingerprintService,
  CancelCashOutInteractor,
  { provide: CancelCashOutRepository, useClass: CancelCashOutImplRepository },
  { provide: ValidationRepository, useClass: ValidationImplRepository },
  { provide: GetCashOutRepository, useClass: GetCashOutImplRepository },
  { provide: ConfirmCashOutRepository, useClass: ConfirmCashOutImplRepository },
];
